module.exports = require("./de.d.ts");